<template>
  <div>
    <div class="layer"></div>
    <div class="leFenWrap">
      <div class="leFenMain">
        <header>
          <span>提示</span>
          <button class="close" @click="close"></button>
        </header>
        <main>
          <h4>请先登录后才能进行此操作</h4>
          <p>
            没有帐号？
            <a href="mk.php?do=reg&callback=mk.php?do=xlsq">去注册</a>
          </p>
        </main>
        <footer>
          <a
            href="mk.php?do=login_lexue&callback=mk.php?do=xlsq"
            class="login"
          >去登录</a>
          <button @click="close">取消</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  methods: {
    close() {
      this.$emit("closeLayer");
    }
  }
};
</script>
<style lang="scss" scoped>
.clear {
  clear: both;
}
.layer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: #000;
  opacity: 0.5;
  z-index: 1000;
}
.leFenWrap {
  position: fixed;
  width: 400px;
  height: 232px;
  top: 50%;
  left: 50%;
  margin-left: -200px;
  margin-top: -166px;
  background: #fff;
  border-radius: 4px;
  z-index: 1001;
}

.leFenMain {
  header {
    height: 54px;
    line-height: 54px;
    padding: 0 30px;
    span {
      float: left;
      font-size: 14px;
      color: #333;
      height: 54px;
    }
    button.close {
      float: right;
      margin-top: 20px;
      border: none;
      width: 13px;
      height: 13px;
      background: url(../../assets/img/close.png) no-repeat;
      outline: none;
      &:hover {
        cursor: pointer;
      }
    }
  }
  main {
    display: table-cell;
    vertical-align: middle;
    width: 400px;
    height: 116px; 
    font-family: "PingFang-SC-Medium";
    text-align: center;
    font-size: 14px;
    h4 {
      display: block;
      font-size: 16px;
      color: #333;
    }
    p {
      margin: 15px 0 0;
      font-size: 14px;
      color: #666;
      a {
        color: #FF7A32;
      }
    }
  }
  footer {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    height: 60px;
    font-size: 16px;
    .login {
      float: left;
      box-sizing: border-box;
      width: 50%;
      text-align: center;
      border-right: 1px solid #e5e5e5;
      color: #ff7a32;
      height: 60px;
      line-height: 60px;
    }
    button {
      float: right;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      width: 50%;
      text-align: center;
      border: none;
      background: none;
      outline: none;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.introEdit {
  width: 260px;
  margin-left: 20px;
  margin-top: 20px;
  .editButtons {
    margin-top: 10px;
    overflow: hidden;
    padding-right: 0px;
    width: 256px;
    button {
      float: right;
      background: #fff;
      border: none;
      margin-left: 16px;
      &:hover {
        cursor: pointer;
      }
    }
    .editSave {
      color: #ca8e6e;
    }
    .editCancel {
      color: #333;
    }
  }
}
</style>

